import React from "react";
import { ReactComponent as SvgLogo } from "../../assets/images/logo.svg";
import { ReactComponent as SvgLogoWhite } from "../../assets/images/logo_white.svg";
import useWindowDimensions from "../../hooks/useWindowDimension";
import { SM_BREAKPOINT } from "../../config/breakpoints";
import { config, useSpring, animated } from "react-spring";

function Logo(props) {
  const { type, fill, stroke } = props;
  const { width } = useWindowDimensions();

  const logoStyle = useSpring({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: width > SM_BREAKPOINT ? 140 : 110,
    width: width > SM_BREAKPOINT ? 140 : 110,
    config: config.stiff,
  });
  return (
    <animated.div style={logoStyle}>
      {(!type || type === "colored") && <SvgLogo fill={fill} stroke={stroke}/>}
      {type === "white" && <SvgLogoWhite />}
    </animated.div>
  );
}

export default Logo;
